const numCounter = () => {
	
	/**
	* GSAP Scroll-Triggered Number Counter
	* Targets all elements with the class "num-counter"
	*
	* Usage:
	*   <span class="num-counter" data-target="1500" data-duration="2" data-prefix="$" data-suffix="+" data-decimals="0">0</span>
	*
	* Data attributes:
	*   data-target    (required) The number to count up to
	*   data-duration  (optional) Animation duration in seconds. Default: 2
	*   data-prefix    (optional) String prepended to the number (e.g. "$")
	*   data-suffix    (optional) String appended to the number (e.g. "+", "%")
	*   data-decimals  (optional) Number of decimal places to display. Default: 0
	*
	* Dependencies:
	*   - GSAP core
	*   - GSAP ScrollTrigger plugin
	*/

	gsap.registerPlugin(ScrollTrigger);

	const counters = document.querySelectorAll('.num-counter');
	if (!counters.length) return;

	counters.forEach((el) => {
		const rawValue  = (el.dataset.target ?? el.innerText).replace(/,/g, '');
		const target    = parseFloat(rawValue);
		const duration  = parseFloat(el.dataset.duration ?? 2);
		const prefix    = el.dataset.prefix  ?? '';
		const suffix    = el.dataset.suffix  ?? '';
		const decimals  = parseInt(el.dataset.decimals ?? 0, 10);

		const obj = { val: 0 };

		gsap.to(obj, {
				val: target,
				duration,
				ease: 'power2.out',
				scrollTrigger: {
						trigger: el,
						start: 'top 85%',  // fires when top of element hits 85% down the viewport
						once: true,         // only animates once per page load
				},
				onUpdate() {
						const formatted = obj.val.toLocaleString('en-US', {
								minimumFractionDigits: decimals,
								maximumFractionDigits: decimals,
						});
						el.textContent = prefix + formatted + suffix;
				},
		});
	});
	
};

export {
	numCounter
};